const CITRA = {
  FOLDERS: 'dossiers',
  USERS: 'utilisateurs',
  FICHES: 'fiches',
  ENTERPRISE: 'entreprises',
  DATA: 'donnees'
};

const PARAMS = {
  FOLDERID: '{folderId}',
  USERID: '{userId}',
  ENTERPRISEID: '{enterpriseId}'
};

const FOLDERS = {
  GET_BY_ID: `${CITRA.FOLDERS}/${PARAMS.FOLDERID}`,
  SUPPORTING_DOCUMENTS: `${CITRA.FOLDERS}/${PARAMS.FOLDERID}/update-justificatifs`,
  SEND: `${CITRA.FOLDERS}/${PARAMS.FOLDERID}/transmettre`
};

const USERS = {
  GET_BY_ID: `${CITRA.USERS}/${PARAMS.USERID}`
};

const ENTERPRISE = {
  GET_BY_ID: `${CITRA.ENTERPRISE}/${PARAMS.ENTERPRISEID}`,
  RECEP_DECLA_PREF: `${CITRA.ENTERPRISE}/${PARAMS.ENTERPRISEID}/justificatifRecepDeclaPref`,
  RECEP_INSERTION: `${CITRA.ENTERPRISE}/${PARAMS.ENTERPRISEID}/justificatifRecepInsertion`
};

const DATA = {
  PASS: `${CITRA.DATA}/pass`
}

export default {
  CITRA,
  DATA,
  ENTERPRISE,
  FOLDERS,
  PARAMS,
  USERS
};
